// @flow

import { StackProps } from "@chakra-ui/react";

export const formItem: StackProps = {
  alignItems: "start"
};
